import { render, staticRenderFns } from "./UploadUserGroup.vue?vue&type=template&id=2bafe0da&scoped=true"
import script from "./UploadUserGroup.vue?vue&type=script&lang=js"
export * from "./UploadUserGroup.vue?vue&type=script&lang=js"
import style0 from "./UploadUserGroup.vue?vue&type=style&index=0&id=2bafe0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bafe0da",
  null
  
)

export default component.exports